import { Duration } from 'date-fns';
import { SnapshotType } from 'app/agriculture/queries/snapshots/config/snapshotConfig';
import { MutableEntityType } from 'app/agriculture/mutations/types/entityConfig';

export type Brand = 'Yarn' | 'Gasbot';
export const brandConfig: Record<
    Brand,
    {
        snapshotShelfLife: Duration;
        levelSnapshotType: 'Level' | 'GasbotLevel';
        offlineLatestSnapshotType: SnapshotType;
        parentType: MutableEntityType;
    }
> = {
    Yarn: {
        snapshotShelfLife: { hours: 1 },
        levelSnapshotType: 'Level',
        offlineLatestSnapshotType: 'Heartbeat',
        parentType: 'Device',
    },
    Gasbot: {
        snapshotShelfLife: { hours: 12 },
        levelSnapshotType: 'GasbotLevel',
        offlineLatestSnapshotType: 'GasbotLevel',
        parentType: 'GasbotDevice',
    },
};
